import React from 'react'
import { browserHistory, Link } from 'react-router'
import FaTwitter from 'react-icons/lib/fa/twitter'
import './navbar.css'

export default function GlobalFooter() {
  return (
    <div className="global-footer">
      <div className="footer-column" style={{width: '240px'}}>
        <div className="footer-header">&nbsp;</div>
        <span>Streamable Inc.</span>
        <span>427 N Tatnall St. 27273<br/>Wilmington, DE 19801<br/>United States</span>
        <span>© 2014 - 2021</span>
        <a href="https://twitter.com/streamable"><FaTwitter /></a>
      </div>
      <div className="footer-column">
        <div className="footer-header">Tools</div> 
        <Link to="/upload-video">Upload Video</Link>
        <Link to="/clipper">Clip from URL</Link>
        <Link to="/trim-video">Trim Video</Link>
        <Link to="/rotate-video">Rotate Video</Link>
        <Link to="/mute-video">Mute Video</Link>
        <Link to="/crop-video">Crop Video</Link>
        <Link to="/compress-video">Compress Video</Link>
        <Link to="/embed-video">Embed Video</Link>
      </div>
      <div className="footer-column" style={{width: '130px'}}>
        <div className="footer-header">Product</div>
        <Link to="/pricing?src_internal=landing-footer-link">Pricing</Link>
        <a href="https://support.streamable.com/frequently-asked-questions">FAQ</a>
        <Link to="/login">Log In</Link>
        <Link to="/signup">Sign Up</Link>
        <a href="https://status.streamable.com">Status</a>
      </div>
      <div className="footer-column">
      <div className="footer-header">Company</div>
        <a href="https://careers.streamable.com">Careers</a>
        <a href="https://support.streamable.com">Support</a>
        <a href="https://privacy.streamable.com">Privacy Policy</a>
        <a href="https://terms.streamable.com">Terms Of Service</a>
        
        <a href="#" onClick={(e) => {
            e.preventDefault(); 
            if (window.Beacon) {
            window.Beacon('open') 
            } else {
            window.location = 'mailto:support@streamable.com'
            }
        }} >Contact Us</a> 
      </div>
    </div>
  )
}
